import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getSubscriptionJobs } from 'queries';
import { parseErrors, Toast } from 'helpers';
import { JsonDataItem } from 'types';

const PER_PAGE = 10;

export const useSubscriptionJobs = (subscriptionId?: number, enabled?: boolean) => {
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery(['subscription-jobs', subscriptionId, page], getSubscriptionJobs, {
    enabled: !!enabled && !!subscriptionId,
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const paginationMetadata = {
    total: data?.total ?? 0,
    current_page: data?.current_page ?? page,
    pageSize: PER_PAGE,
    onChange: (nextPage: number) => setPage(nextPage),
  };

  return {
    jobs: data?.data,
    totalHours: data?.total_hours,
    paginationMetadata,
    setPage,
    isLoading,
  };
};
